<template>
  <tr>
    <td class="text-left font-weight-bold">{{ title }}</td>
    <td colspan="2"></td>
    <td class="text-right font-weight-bold">{{ montant }}</td>
  </tr>
</template>

<script>
export default {
  props: {
    title: String,
    montant: String
  }
}
</script>

<style>
</style>